// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1ecmr","card":"Cards_card__1UmEW","infected":"Cards_infected__3tp8Y","recovered":"Cards_recovered__3Cw9A","deaths":"Cards_deaths__Ew6R_"};